import { render, staticRenderFns } from "./WatchRecord.vue?vue&type=template&id=f5b54a14&scoped=true&"
import script from "./WatchRecord.vue?vue&type=script&lang=js&"
export * from "./WatchRecord.vue?vue&type=script&lang=js&"
import style0 from "./WatchRecord.vue?vue&type=style&index=0&id=f5b54a14&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b54a14",
  null
  
)

export default component.exports